import React, {Suspense, useEffect} from 'react'
import {BrowserRouter} from 'react-router-dom'
import {I18nProvider} from '../_metronic/i18n/i18nProvider'
import {LayoutProvider, LayoutSplashScreen} from '../_metronic/layout/core'
import AuthInit from './modules/auth/redux/AuthInit'
import {Routes} from './routing/Routes'
import {login} from './modules/auth/redux/AuthCRUD'
import * as auth from './modules/auth/redux/AuthRedux' 
import {useDispatch} from 'react-redux'
  


import config from 'react-global-configuration';

type Props = {
  basename: string
}


declare global {
    interface Window { FormSettings: any; CvValues: any; }
}

window.FormSettings = window.FormSettings || {};
window.CvValues = window.CvValues || {};


const App: React.FC<Props> = ({basename}) => {

  //CONFIG DRUPAL ENV
  config.set({'drupal_url':'http://dev.admin.recherche.pprod.net'});
  
  const dispatch = useDispatch()
  
  useEffect(() => {
      setTimeout(() => {
	    /*** CHECK COOKIE CONNEXION DRUPAL ***/
        login("", "")
            .then((response) => {
              
              if(response.data.access_token){
              	dispatch(auth.actions.login(response.data.access_token, '', ''))
              }else{
	            dispatch(auth.actions.login('', response.data, ''))
              }
              
            })
            .catch((error) => {
              
            })
      }, 1000)
  }, [])

  return (
    <Suspense fallback={<LayoutSplashScreen />}>
      <BrowserRouter basename={basename}>
        <I18nProvider>
          <LayoutProvider>
            <AuthInit>
              <Routes />
            </AuthInit>
          </LayoutProvider>
        </I18nProvider>
      </BrowserRouter>
    </Suspense>
  )
}

export {App}
